module.exports = __webpack_public_path__ + "img/list_2.4ebda7d7.jpg";